// extracted by mini-css-extract-plugin
export var container = "_gq-0";
export var segment = "_gq-2";
export var segmentActive = "_gq-3";
export var track = "_gq-1";